import React from 'react';
import '../styles/ProductReviews.css';
import ProductReviewCard from './ProductReviewCard.jsx';

const ProductReviews = ({ ProductReviews }) => {
  return (
    <div className="ProductReviews">
      {ProductReviews.map((item, index) => (
        <ProductReviewCard
          key={item.index}
          index={index}
          price={item.price}
          name={item.name}
          image={item.image}
          review={item.review}
        />
      ))}
    </div>
  );
};

export default ProductReviews;
